import axios, { AxiosError, AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import { logout, store } from '../redux/internal';
import { toastAutoClose } from '../constants/application';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const token = store.getState().auth.token;
  if (token && config.headers) {
    config.headers['Authorization'] = `Bearer ${token.access_token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,
    if (error?.request?.status === 401) {
      toast.error('Your session has expired, please log back in.', { toastId: 401 });
      setTimeout(() => {
        void store.dispatch(logout());
      }, toastAutoClose);
    } else {
      toast.error(axios.isAxiosError(error) ? error.message : (error as string));
    }

    return Promise.reject(error);
  }
);
